import { render, staticRenderFns } from "./KBIconButton.vue?vue&type=template&id=4c9f46ec&scoped=true&"
import script from "./KBIconButton.vue?vue&type=script&lang=js&"
export * from "./KBIconButton.vue?vue&type=script&lang=js&"
import style0 from "./KBIconButton.vue?vue&type=style&index=0&id=4c9f46ec&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9f46ec",
  null
  
)

export default component.exports